import { Button, Classes, Dialog } from '@blueprintjs/core'
import React, { useState } from 'react'
import CloseIcon from '~/icons/CloseIcon'

export const PreviewDialog = props => {
  const { title, icon, content, desc } = props
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = React.useCallback(() => setIsOpen(false), [])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div style={{alignSelf: 'flex-end'}}>
      <Button className={'template-preview-btn'} type="button" text={'Preview'} onClick={toggle} />
      <Dialog icon={icon} isOpen={isOpen} canEscapeKeyClose={true} canOutsideClickClose={true} onClose={handleClose}
              style={{width: '70%'}}>
        <div className={Classes.DIALOG_HEADER}>
          <h4 className="bp3-heading">{title}</h4>
          <button aria-label="Close" className="bp3-dialog-close-button bp3-button bp3-minimal" onClick={toggle}>
            <CloseIcon />
          </button>
        </div>
        <div className={Classes.DIALOG_BODY} style={{maxWidth: '100%', height:'80%', border: '1px solid #b5c5cd', borderRadius: '10px', boxShadow: '0 2px 14px rgb(172, 202, 217)'}} >
          <img src={content} style={{width: '100%', height: '100%',  borderRadius: '10px' }}/>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <p> {props.desc}</p>
        </div>
      </Dialog>
    </div>
  )
}

export default PreviewDialog
